// extracted by mini-css-extract-plugin
export default {"sticky":"IndirectFormTable_sticky__9MaAR","stickyTop":"IndirectFormTable_stickyTop__kB11W"};